<template>
  <div>
    <Dialog v-model:visible="visible" modal :closable="false" :header="title" :style="{ width: '50vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <div class="flex flex-col">
        <StdPropEditor v-model="emailCopy.id" class="w-full" :prop-def="propsDefs['id']" />
        <label class="mt-4 block text-sm font-medium leading-6 text-gray-900">Bot</label>
        <label class="mb-1 text-sm">Select a Bot to handle {{ types[props.type] }}</label>
        <div class="flex items-center">
          <Dropdown v-model="emailCopy.botId" :options="botsStore.bots" filter option-label="name" option-value="id" placeholder="Select a Bot" class="md:w-14rem w-full"></Dropdown>
          <Button v-tooltip.top="'Clear'" icon="pi pi-times" severity="secondary" class="ml-2" @click="emailCopy.botId = null" />
        </div>
        <label class="mt-4 block text-sm font-medium leading-6 text-gray-900">Integration</label>
        <label :style="emailCopy.integrations.length === 1 && { visibility: 'hidden' }" class="mb-1 text-sm">Select an Integration</label>
        <div class="flex items-center">
          <input ref="integrationNameRef" v-model="emailCopy.integrationName" type="text" style="position: absolute; left: -9999px; top: -9999px" required />
          <Dropdown
            v-model="emailCopy.integrationName"
            :disabled="edit || emailCopy.integrations.length === 1"
            :options="emailCopy.integrations"
            filter
            option-label="name"
            option-value="id"
            placeholder="Select an Integration"
            class="md:w-14rem w-full"
            :class="{ 'ring-1 ring-red-500 focus:ring-1 focus:ring-red-500': !integrationNameRef?.value?.validity?.valid && savedIntegration }"
            @change="onIntegrationChange"
          ></Dropdown>
        </div>
        <div v-if="['kustomer', 'salesforce'].includes(emailCopy.integrationName)">
          <label class="mt-4 block text-sm font-medium leading-6 text-gray-900">Email Templates</label>
          <label class="mb-1 text-sm">Select an Email Template</label>
          <div class="flex items-center">
            <Dropdown
              v-model="emailCopy.templateId"
              :options="emailTemplates"
              filter
              :option-label="templateLabelKey"
              :option-value="templateValueKey"
              :disabled="loadingEmailTemplates"
              :placeholder="loadingEmailTemplates ? '⏳ Loading...' : 'Select an Email Template'"
              class="md:w-14rem w-full"
            ></Dropdown>
            <Button v-tooltip.top="'Clear'" :disabled="loadingEmailTemplates" icon="pi pi-times" severity="secondary" class="ml-2" @click="emailCopy.templateId = null" />
          </div>
        </div>
        <div v-if="emailCopy.integrationName === 'kustomer'">
          <label class="mt-4 block text-sm font-medium leading-6 text-gray-900">Routing Queue</label>
          <label class="mb-1 text-sm">Select a Routing Queue</label>
          <div class="flex items-center">
            <Dropdown
              v-model="emailCopy.queueId"
              :options="queues"
              filter
              option-label="displayName"
              option-value="id"
              :disabled="loadingQueues"
              :placeholder="loadingQueues ? '⏳ Loading...' : 'Select a Routing Queue'"
              class="md:w-14rem w-full"
            ></Dropdown>
            <Button v-tooltip.top="'Clear'" :disabled="loadingQueues" icon="pi pi-times" severity="secondary" class="ml-2" @click="emailCopy.queueId = null" />
          </div>
        </div>
        <div v-if="emailCopy.integrationName === 'salesforce'">
          <label class="mt-4 block text-sm font-medium leading-6 text-gray-900">Sender Email Address</label>
          <label class="mb-1 text-sm">Select an Organization-Wide Email Address</label>
          <div class="flex items-center">
            <Dropdown
              v-model="emailCopy.senderAddress"
              :options="senderAddresses"
              filter
              option-label="Address"
              option-value="Address"
              :disabled="loadingOrgWideEmailAddresses"
              :placeholder="loadingOrgWideEmailAddresses ? '⏳ Loading...' : 'Select an Address'"
              class="md:w-14rem w-full"
            ></Dropdown>
            <Button v-tooltip.top="'Clear'" :disabled="loadingOrgWideEmailAddresses" icon="pi pi-times" severity="secondary" class="ml-2" @click="emailCopy.senderAddress = null" />
          </div>
        </div>
        <!--        <div v-else class="flex items-center">{{ emailCopy.integrations[0].name }}</div>-->
        <!-- TODO Enable when SMS Phone numbers are available
        <label class="block text-sm font-medium leading-6 text-gray-900 mt-2">SMS Bot</label>
        <label class="text-sm mb-1">Select a Bot to handle SMS</label>
        <div class="flex items-center">
          <Dropdown v-model="numberCopy.smsBotId" :options="botsStore.bots" filter optionLabel="name" optionValue="id" placeholder="Select a Bot" class="w-full md:w-14rem"></Dropdown>
          <Button v-tooltip.top="'Clear'" icon="pi pi-times" @click="numberCopy.smsBotId = null" severity="secondary" class="ml-2" />
        </div>
        -->
        <!--
        <StdPropEditor class="w-full mt-4" :prop-def="propsDefs['handoffNumber']" v-model="numberCopy.handoffNumber" />
        <StdPropEditor class="col-span-4" :prop-def="propsDefs['handoffNumber']" v-model="numberCopy.handoffNumber" />
        <BotSelector v-model="numberCopy.voiceBotId" :label="propsDefs['voiceBotId'].title" :description="propsDefs['voiceBotId'].description"></BotSelector>
        <label class="text-sm mt-4">Description</label>
        <StdPropEditor class="col-span-4" :prop-def="categoryPropDefs['description']" v-model="categoryCopy.description" />
        <label class="text-sm mt-4">KPIs</label>
        <label class="text-xs mt-1 mb-2">Only analyze selected KPIs for this Category and child categories. Keep blank to analyze all. </label>
        <StdItemMultiSelect v-model="categoryCopy.kpis" :availableItems="categoriesStore.catKpis" :disableAddItem="true"></StdItemMultiSelect>
        <label>TODO Tags</label>
        <MultiSelect v-model="hcSubdomainsSelected" :options="hcSubdomains" placeholder="Select Subdomains" :maxSelectedLabels="3" class="w-full" />
        -->
      </div>
      <template #footer>
        <Button label="Cancel" severity="secondary" autofocus @click="visible = false" />
        <Button label="Save" :disabled="!saveEnabled" severity="primary" autofocus @click="onSave" />
      </template>
    </Dialog>
  </div>
</template>

<script setup>
  import { useRbacStore } from '@/store/RBACStore';
  import { useBotsStore } from '@/store/BotsStore';
  import { useToast } from 'vue-toastification';
  import { ref, reactive, nextTick, computed, watch } from 'vue';
  import InputText from 'primevue/inputtext';
  import { getUUID, pathPut } from '@enegelai/core';
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import Message from 'primevue/message';
  import MultiSelect from 'primevue/multiselect';
  import Dropdown from 'primevue/dropdown';
  import StdPropEditor from '@/components/Editors/StdPropEditor.vue';
  import StdItemMultiSelect from '@/components/Editors/StdItemMultiSelect.vue';
  import { useApi } from '@/hooks/useApi';

  const api = useApi();
  function loadKustomerData() {
    loadingEmailTemplates.value = true;
    api.kustomerGetEmailTemplates({}).then(({ data }) => {
      loadingEmailTemplates.value = false;
      emailTemplates.value = data;
    });
    loadingQueues.value = true;
    api.kustomerGetQueues({}).then(({ data }) => {
      loadingQueues.value = false;
      queues.value = data;
    });
  }
  function loadSalesForceData() {
    loadingEmailTemplates.value = true;
    api.salesForceGetEmailTemplates({}).then(({ data }) => {
      loadingEmailTemplates.value = false;
      emailTemplates.value = data;
    });
    loadingOrgWideEmailAddresses.value = true;
    api.salesForceGetOrgWideEmailAddresses({}).then(({ data }) => {
      loadingOrgWideEmailAddresses.value = false;
      senderAddresses.value = data;
    });
  }
  const emit = defineEmits(['save']);

  const props = defineProps({
    type: {
      type: String,
      default: '',
    },
  });

  const botsStore = useBotsStore();

  const visible = ref(false);
  const integrationNameRef = ref(false);

  const emailCopy = ref(reactive({}));

  const types = {
    sms: 'SMS',
    email: 'Email',
  };

  const title = computed(() => {
    return `${edit.value ? 'Edit' : 'New'} ${types[props.type]} ${emailCopy.value?.id}`;
  });

  const templateLabelKey = computed(() => (emailCopy.value?.integrationName === 'salesforce' ? 'Name' : 'name'));
  const templateValueKey = computed(() => (emailCopy.value?.integrationName === 'salesforce' ? 'Id' : 'id'));

  // Definition of editable category properties
  const propsDefs = reactive({
    id: {
      type: 'string',
      required: true,
      extraType: props.type === 'email' ? 'email' : '',
      title: types[props.type],
      description: `${props.type === 'email' ? 'Email address' : 'Phone number for SMS'} provisioned in CRM or enter - default`,
    },
    /*
    handoffNumber: { type: 'string', required: true, title: 'Handoff Number', description: 'Phone Number to send call on Hand Off', placeholder: 'Phone number in format NNN-NNN-NNNN' },
    voiceBotId: { type: 'string', required: true, label: 'Voice Bot', placeholder: 'Select Voice Bot assigned to this Phone Number' },
    */
  });

  const saveEnabled = computed(() => emailCopy.value.id && emailCopy.value.id !== '');
  const edit = ref(false);
  const loadingEmailTemplates = ref(false);
  const loadingQueues = ref(false);
  const loadingOrgWideEmailAddresses = ref(false);
  const emailTemplates = ref([]);
  const senderAddresses = ref([]);
  const queues = ref([]);
  const savedIntegration = ref(false);

  const loaders = {
    kustomer: loadKustomerData,
    salesforce: loadSalesForceData
  };

  async function start(emailDoc, integrations) {
    edit.value = Object.keys(emailDoc).length;

    Object.assign(propsDefs.id, { valid: true, saved: false });

    // Extract all category properties that we can edit in this dialog, set default values if not provided
    const emailEditableProps = {
      id: emailDoc?.id || '',
      botId: emailDoc?.botId || null,
      templateId: emailDoc?.templateId || null,
      queueId: emailDoc?.queueId || null,
      senderAddress: emailDoc?.senderAddress || null,
      integrationName: integrations.length === 1 ? integrations[0].id : emailDoc?.integrationName || null,
      integrations,
    };

    loaders[emailEditableProps?.integrationName]?.();

    // Make a deep reactive clone of the category object to avoid changing the original object
    emailCopy.value = reactive(JSON.parse(JSON.stringify(emailEditableProps)));

    visible.value = true;
  }

  function onSave() {
    if (!integrationNameRef?.value?.validity?.valid) {
      savedIntegration.value = true;
    }
    if (!propsDefs.id.valid || !integrationNameRef?.value?.validity?.valid) {
      Object.assign(propsDefs.id, { saved: true });
      return;
    }
    emit('save', emailCopy.value);
    visible.value = false;
  }

  function onIntegrationChange() {
    loaders[emailCopy.value?.integrationName]?.();
    savedIntegration.value = false;
  }

  defineExpose({ start });
</script>
